import { render, staticRenderFns } from "./Datasets.vue?vue&type=template&id=2b9047ee&scoped=true"
import script from "./Datasets.vue?vue&type=script&lang=js"
export * from "./Datasets.vue?vue&type=script&lang=js"
import style0 from "./Datasets.vue?vue&type=style&index=0&id=2b9047ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9047ee",
  null
  
)

export default component.exports